import { useGetOrganization } from "@/hooks/useOrganizations"
import { useNavigate, useParams } from "react-router-dom"
import { useApp } from "../../AppProvider"
import { Button, Spinner } from "../common"
import { ErrorMessage } from "../common/Feedback/ErrorMessage"
import { BackgroundSync } from "./BackgroundSync"
import { AntechConfigForm } from "./providerConfig/AntechConfigForm"
import { IdexxConfigForm } from "./providerConfig/IdexxConfigForm"
import { ZoetisConfigForm } from "./providerConfig/ZoetisConfigForm"

export const OrganizationDetails = () => {
  const { token } = useApp()
  const { organizationId } = useParams()
  const navigate = useNavigate()
  const { data: org, isLoading, isError, error } = useGetOrganization(organizationId ?? "", token)

  if (isLoading) {
    return (
      <div className="card">
        <div className="mx-auto my-3">
          <Spinner />
        </div>
      </div>
    )
  }

  if (isError || !organizationId) {
    return (
      <div className="card">
        <div className="mx-auto my-3">
          <ErrorMessage message={error?.message ?? "Unknown error"} />
        </div>
      </div>
    )
  }

  return (
    <div className="card">
      <div className="flex justify-between">
        <h2 className="text-lg font-semibold text-gray-900">{org?.name}</h2>
        <div className="flex items-center gap-x-2">
          <Button variant="outline" onClick={() => navigate(`/private/organizations/${organizationId}/edit`)}>
            Edit
          </Button>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-1 gap-8 border-t pt-4 md:grid-cols-3">
        <AntechConfigForm orgId={organizationId} />
        <IdexxConfigForm orgId={organizationId} />
        <ZoetisConfigForm orgId={organizationId} />
      </div>

      <div className="mt-4 border-t pt-4">
        <BackgroundSync organizationId={organizationId} />
      </div>
    </div>
  )
}
